/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuHoursGroupsResponse } from '../../models/menu-hours-groups-response';

export interface MenuHoursGroupsGet$Params {
  'Active-Tenant-Identifier': string;
  menuId: string;
}

export function menuHoursGroupsGet(http: HttpClient, rootUrl: string, params: MenuHoursGroupsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuHoursGroupsResponse>> {
  const rb = new RequestBuilder(rootUrl, menuHoursGroupsGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('menuId', params.menuId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuHoursGroupsResponse>;
    })
  );
}

menuHoursGroupsGet.PATH = '/menus/{menuId}/hours';
